/**
 * Shared location data for frontend.
 * Maps WatsName (used as ID) to display Name and Address details.
 */

export const LOCATIONS = [
    {
        id: "IMA-ALBANY",
        name: "Albany",
        address: {
            line1: "1762 Central Ave",
            line2: "Suite 202",
            city: "Albany",
            state: "NY",
            zip: "12205"
        },
        phone: "5183891310"
    },
    {
        id: "IMA-BING",
        name: "Endicott",
        address: {
            line1: "609 East Main Steet",
            line2: "Suite 1",
            city: "Endicott",
            state: "NY",
            zip: "13760"
        },
        phone: "6072370645"
    },
    {
        id: "IMA-BRONX",
        name: "Bronx",
        address: {
            line1: "3250 Westchester Ave",
            line2: "Suite 120",
            city: "Bronx",
            state: "NY",
            zip: "10461"
        },
        phone: "7184142601"
    },
    {
        id: "IMA-BUFF",
        name: "Buffalo",
        address: {
            line1: "699 Hertel Avenue",
            line2: "Suite 355",
            city: "Buffalo",
            state: "NY",
            zip: "14207"
        },
        phone: "7168774204"
    },
    {
        id: "IMA-CONT-R",
        name: "Rochester",
        address: {
            line1: "214 Alexander Street",
            line2: "Suite 200",
            city: "Rochester",
            state: "NY",
            zip: "14607"
        },
        phone: "5854734890"
    },
    {
        id: "IMA-HOLBRK",
        name: "Farmingville",
        address: {
            line1: "1075 Portion Rd.",
            line2: "",
            city: "Farmingville",
            state: "NY",
            zip: "11738"
        },
        phone: "6316489062"
    },
    {
        id: "IMA-JAMES",
        name: "Jamestown",
        address: {
            line1: "405 Spring Street",
            line2: "",
            city: "Jamestown",
            state: "NY",
            zip: "14701"
        },
        phone: "7164887089"
    },
    {
        id: "IMA-MAN",
        name: "Manhattan",
        address: {
            line1: "42 Broadway",
            line2: "19th Floor, Suite 1900",
            city: "New York",
            state: "NY",
            zip: "10004"
        },
        phone: "2123632650"
    },
    {
        id: "IMA-ORANGE",
        name: "Middletown",
        address: {
            line1: "643 Route 211 East",
            line2: "Unit # 2 (Middle Unit)",
            city: "Scotchtown",
            state: "NY",
            zip: "10941"
        },
        phone: "8453425030"
    },
    {
        id: "IMA-PLATTS",
        name: "Plattsburgh",
        address: {
            line1: "High Peaks Commons",
            line2: "675 State Route 3/NY-3, #101",
            city: "Plattsburgh",
            state: "NY",
            zip: "12901"
        },
        phone: "5185618632"
    },
    {
        id: "IMA-SYRAC",
        name: "North Syracuse",
        address: {
            line1: "100 Elwood Davis Road",
            line2: "1st Floor",
            city: "North Syracuse",
            state: "NY",
            zip: "13212"
        },
        phone: "3154235039"
    },
    {
        id: "IMA-WATER",
        name: "Watertown",
        address: {
            line1: "428 Washington St.",
            line2: "Suite 1",
            city: "Watertown",
            state: "NY",
            zip: "13601"
        },
        phone: "3156816220"
    },
    {
        id: "IMA-WP",
        name: "Hartsdale",
        address: {
            line1: "220 North Central Avenue",
            line2: "Second Floor",
            city: "Hartsdale",
            state: "NY",
            zip: "10530"
        },
        phone: "9144379430"
    },
    {
        id: "IMA-BKLYN",
        name: "Brooklyn",
        address: {
            line1: "50 Court Street",
            line2: "Lower level",
            city: "Brooklyn",
            state: "NY",
            zip: "11201"
        },
        phone: "7182374572"
    },
    {
        id: "IMA-QUEENS",
        name: "Kew Gardens (Queens)",
        address: {
            line1: "80-02 Kew Gardens Rd",
            line2: "Suite 102",
            city: "Kew Gardens",
            state: "NY",
            zip: "11415"
        },
        phone: "7185216201"
    },
    {
        id: "IMA-POUGH",
        name: "Poughkeepsie",
        address: {
            line1: "301 Manchester Rd.",
            line2: "Suite 202 (2nd Floor)",
            city: "Poughkeepsie",
            state: "NY",
            zip: "12603"
        },
        phone: "8454528500"
    },
    {
        id: "IMA-ELMIRA",
        name: "Elmira",
        address: {
            line1: "1300 College Ave",
            line2: "",
            city: "Elmira",
            state: "NY",
            zip: "14901"
        },
        phone: "6077323630"
    },
    {
        id: "IMA-HEMPST",
        name: "Hempstead",
        address: {
            line1: "250 Fulton Ave",
            line2: "Room 407",
            city: "Hempstead",
            state: "NY",
            zip: "11550"
        },
        phone: "5165051364"
    },
    {
        id: "IMA-UTICA",
        name: "Utica",
        address: {
            line1: "587 Main Street",
            line2: "Suite 108",
            city: "New York Mills",
            state: "NY",
            zip: "13417"
        },
        phone: "3158648594"
    },
    {
        id: "IMA-STATEN",
        name: "Staten Island",
        address: {
            line1: "380 Van Duzer Street",
            line2: "First Floor",
            city: "Staten Island",
            state: "NY",
            zip: "10304"
        },
        phone: "3022681425"
    }
];

export const getLocationById = (id) => {
    return LOCATIONS.find(loc => loc.id === id);
};

export const getLocationName = (id) => {
    const loc = getLocationById(id);
    return loc ? loc.name : id;
};
